<template>
    <div>
        <b-tabs pills vertical content-class="col-12 col-md-9 mt-1 mt-md-0" nav-class="nav-left"
            nav-wrapper-class="col-md-3 col-12">
            <b-tab active>
                <template #title>
                    <feather-icon icon="UserIcon" size="18" class="mr-50" />
                    <span class="font-weight-bold">General</span>
                </template>
                <form-create-property :projects="projects"></form-create-property>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import FormCreateProperty from './details/property/FormCreateProperty'

export default {
    name: 'PropertysDetailsCreate',
    props: ['projects'],
    components: {
        FormCreateProperty
    },
    data() {
        return {
        }
    },
}
</script>